import AccordionHeading from './Accordion.Heading'
import AccordionBody from './Accordion.Body'
import AccordionItem from './Accordion.Item'
import AccordionWrapper from './Accordion'

const Accordion = {
  Wrapper: AccordionWrapper,
  Item: AccordionItem,
  Heading: AccordionHeading,
  Body: AccordionBody
}

export default Accordion
